module.exports = "https://de18y2hs3hlxs.cloudfront.net/ea0f2244-3733-4462-8521-3c67071db2f1/images/LogoHorizontal_White.svg?9c112b852f8360595639d7074f825d62";